import React from 'react'

type Props = {
    className?      : string

    title           : string
    disabled        : boolean
    isFoldable      : boolean
    isOpen          : boolean
    delimiter       : boolean
    onOpenClosed    : func
    headerRenderer? : func

    counter         : number | null
    showClearButton : boolean
    isAnimated      : boolean
    onClear         : func

    children?       : any
}

type State = {
    isOpen: boolean
}

export default class FoldableBlock extends React.Component<Props, State> {

    static defaultProps = {
        disabled    : false,
        delimiter   : true,
        isAnimated  : false
    }

    constructor(props: Props) {
        super(props)

        this.state = {
            isOpen: !props.disabled && props.isOpen
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (nextProps.disabled) {
            this.setState({
                isOpen: false
            })
        }
    }

    onFoldBtnClick = () => {
        if (this.props.isFoldable && !this.props.disabled) {
            let newIsOpen = !this.state.isOpen
            if (this.props.onOpenClosed) this.props.onOpenClosed(newIsOpen)

            this.setState({
                isOpen: newIsOpen
            })
        }
    }

    onClear = (e: React.MouseEvent) => {
        e.stopPropagation()

        if (this.props.onClear) this.props.onClear()
    }

    renderHeader = () => {
        let foldBtnClasses = Classes({
            'fold-btn'              : true,
            'i5-big-angle-down'    : !this.state.isOpen,
            'i5-big-angle-up'      : this.state.isOpen
        })

        let foldButton, header

        if (this.props.isFoldable)
            foldButton = <div className={foldBtnClasses}/>

        if (this.props.headerRenderer) {
            header = this.props.headerRenderer(this.state.isOpen)
        } else {
            header = <h3>{this.props.title}</h3>
        }

        if (this.props.title || this.props.isFoldable) {
            const headerClasses = Classes("block-header", {
                "is-disabled": this.props.disabled
            })

            return (
                <div className={headerClasses} onClick={this.onFoldBtnClick}>
                    {header}
                    {this.props.counter !== null && <div className="filter-counter">{this.props.counter}</div>}
                    {this.props.showClearButton && <div className="clear-button i5-delete" onClick={this.onClear}/>}
                    {foldButton}
                    <div className="cf"/>
                </div>
            )
        }
    }

    render() {
        let classes = Classes("block-foldable", this.props.className, {
            "expanded"      : this.state.isOpen,
            "is-animated"   : this.props.isAnimated
        })

        const showContent = this.state.isOpen || this.props.isAnimated

        return (
            <div className={classes}>
                {this.props.delimiter && <div className="delimiter"/>}
                {this.renderHeader()}
                {showContent && <div className="block-content">{this.props.children}</div>}
            </div>
        );
    }
}